import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    topic: '', //当前主题
    subTopic: '',
    appInstance: false, // 地图初始化成功
    sceneName: 'ShenZhenWan', // 当前场景名称, 此处必须写地图默认关卡名称
    sceneTime: '时间', // 地图时间
    sceneWeather: '晴天', // 地图天气
    cameraInfo: '', //摄像机视角
    cameraRotate: false, //相机旋转
    highLight: '', // 当前高亮的卡片
    selectCity: '', // 下拉菜单选择的城市
    prevModelLayer: '',
    landmarkLayerIdObj: '', //为散点点击时，参数的数据
    showPortInfo:false
  },
  mutations: {
    setShowPortInfo(state, name) {
      state.showPortInfo = name;
    },
    setLandmarkLayerIdObj(state, name) {
      state.landmarkLayerIdObj = name;
    },
    setModelTip(state, name) {
      state.prevModelLayer = name;
    },
    // 切换主题
    setTopic(state, name) {
      state.topic = name;
    },
    // 设置二级专题
    setSubTopic(state, name) {
      state.subTopic = name;
    },
    // 地图是否初始化
    setAppinstance(state, flag) {
      state.appInstance = flag;
    },
    // 设置高亮卡片
    setHighLight(state, name) {
      state.highLight = state.highLight == name ? state.subTopic : name;
    },
    setSceneName(state, info) {
      state.sceneName = info;
    },
    setCameraInfo(state, info) {
      state.cameraInfo = info;
    },
    setSceneTime(state, info) {
      state.sceneTime = info;
    },
    setSceneWeather(state, info) {
      state.sceneWeather = info;
    },
    setCameraRotate(state, flag) {
      state.cameraRotate = flag
    },
    // 设置下拉菜单选择的城?
    changeSelectCity(state, val) {
      state.selectCity = val;
    },
  },
  actions: {},
  modules: {},
});
